<template>
  <v-app>
    <v-main>
      <div class="product_main div_border">
        <ProductMain />
      </div>
      <div class="Main_Filter div_border">
      <MainFilters />
      </div>
        <PageLoader/>
    </v-main>
    
  </v-app>
</template> 

<script>
import MainFilters from "./components/groupvue.vue";
import ProductMain from "./components/productMain.vue";
import PageLoader from './components/PageLoader.vue';
import logged_in from './classes/logged_in';

export default {
  name: "App",
  components: {
    ProductMain,
    MainFilters,
     PageLoader
  },
  mounted(){
    console.info('mounted');
    let v = new logged_in();
    v.getLoggedIn('test').then( (response)=>{
      if (response.data.logged){
        this.$store.commit('logged_in', true);
      }
    });
  },
  methods:{
      test(rr){
      console.info(rr)
      let v = new logged_in();
      v.getLoggedIn('test');
    }
  }
};
</script>

<style scoped>

.v-application {
   font-family: 'Montserrat', sans-serif !important;
 }

#zmmtg-root {
  display: none;
}
.paginaprodotto p {
  margin: 0;
  padding: 0;
}
.mdi-chevron-right {
  width: 52px;
  height: 52px;
  /* background: url("../assets/svg/back.svg"); */
}
.active_image {
  opacity: 1;
}
.not_active_image {
  opacity: 0.3;
}
.BOX {
  width: 100px;
  height: 100px;
}
.flex-container.wrap {
  display: flex;
  flex-wrap: wrap;
}
.flex-container {
  width: 500px;
}
.product-list-modello {
  display: flex;
  flex-direction: column;
}
.no-margin {
  padding: 0 !important;
  margin: 0 !important;
  margin-top: -40px !important;
  font-weight: 400;
  font-size: 19px;
  text-align: left;
  width: 58%;
}
.no-shadow {
  box-shadow: none !important;
}
.flex_struttura {
  display: flex;
  flex-direction: column;
}
.flex_vetro {
  display: flex;
  flex-direction: column;
  margin: 0;
}
.maiuscoletto_opaco_piccolo {
  font-weight: 400;
  opacity: 1;
  font-size: 5px !important;
  color: #656565;
}
.pesante_scuro {
  font-weight: 550;
  font-size: 14px;
  text-align: left !important;
  align-content: flex-start !important;
}
.img_vetro {
  height: 70px;
  width: 70px;
  object-fit: contain;
  padding-bottom: 0px;
}

.img_montatura {
  height: 70px;
  width: 70px;
  object-fit: contain;
  padding-bottom: 0px;
}
.opaco_si {
  opacity: 0.5;
}
p.vetro_testo {
  margin: 0;
  padding-top: 12px;
  text-align: left !important;
}
.v-card-rompi::before {
  display: none;
}
.paginaprodotto {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
}
.finitura_vetro p {
  padding-left: 70px;
  margin-bottom: 7px;
  font-size: 13px !important;
}
.finitura_montatura p {
  padding-left: 70px;
  margin-bottom: 7px;
  margin-bottom: -15px;
}
.montatura-sheet {
  margin-left: 53px !important;
  margin-top: -26px;
}
.testo_modelli {
  font-size: 15px;
  font-weight: 600;
}

.v-select__selections input {
  border: 0 !important;
  outline: 0 !important;
  background: transparent !important;
  border-image: none !important;
  outline-offset: -2px !important;
  border-color: transparent !important;
  outline-color: transparent !important;
  box-shadow: none !important;
  -webkit-appearance: none !important;
}
.list-sorgente-luminosa {
  padding-left: 70px;
  min-width: 85%;
}
.padding-title {
  padding-left: 70px !important;
}
.testo_finitura_vetro,
.finitura_montatura {
  position: relative;
  z-index: 20;
  margin-bottom: 7px;
}
.sorgente_luminosa_p p {
  font-weight: 500 !important;
  font-size: 13px !important;
  padding-top: 20px;
}

.titoletto_certificazioni {
  font-weight: 500 !important;
  font-size: 13px !important;
  padding-left: 70px;
  padding-top: 20px;
}

.montatura-vetro {
  margin-top: -35px;
}
p.finitura_montatura {
  font-weight: 500 !important;
  font-size: 13px !important;
  padding-bottom: 12px;
}
.list-prezzo {
  width: 50%;
}
.certificazioni_flex {
  display: flex;
  flex-direction: row;
}
.not_active_button {
  opacity: 0.5;
}

.quantity_toggle {
  display: flex;
  margin-left: 70px;
  margin-top: 20px;
  margin-bottom: 30px;
  border: 0.5px;
  border-color: #888;
  border-style: solid;
}

.quantity_toggle_input {
  border-top: none !important;
  border-bottom: none !important;
  width: 2.5rem;
  text-align: center;
  padding: 0 0.5rem;
  background: #ffffff;
  border-left: solid;
  border-left-width: 0.1rem;
  border-left-color: rgb(204, 204, 204);
  border-right: solid;
  border-right-width: 0.1rem;
  border-right-color: rgb(204, 204, 204);
}

.quantity_toggle_button {
  padding: 0.5rem;
  background: #ffffff;
  color: #888;
  font-size: 1rem;
  cursor: pointer;
}

.button-eletrificazioni {
  min-width: 55% !important;
  padding-top: 10px;
}

.v-text-field {
  padding-top: 0px !important;
}

.v-slide-group__wrapper {
  padding-top: 6% !important;
}

.row {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  margin: 0px;
}

.list-codicearticolo {
  padding-top: 15px;
}

.codice_articolo_value_maiuscoletto {
  font-weight: 550;
  font-size: 13px;
  text-align: left !important;
  padding-top: 10px !important;
}

.list-disponibilità_text {
  padding-top: 15px;
}

.disponibilità_top_text {
  font-weight: 400;
  font-size: 13px;
  text-align: left !important;
  padding-top: 10px !important;
}

.button-buy-under-text-center {
  text-align: center !important;
  padding-left: 70px;
  padding-top: 20px;
  padding-bottom: 50px;
}
.div_min_width_20 {
  min-width: 15px !important;
}

.row_double_button {
  margin-top: 15px !important;
}

.prezzo_finale {
  font-weight: 500;
  font-size: 29px;
  text-align: left !important;
  padding-top: 5px !important;
  padding-bottom: 15px !important;
}
.breadcrumbs-product {
  padding-left: 76px;
}
.famiglia {
  padding-left: 100px;
}
.countprodotto {
  padding-left: 100px;
  font-size: 15px !important;
  color: #20221e;
  padding-top: 30px;
  z-index: 100;
  position: relative;
}
.v-application a {
  color: black !important;
  font-weight: 600 !important;
}
.count_proddoto {
  font-size: 15px !important;
}

.v-slide-group__next,
.v-slide-group__prev {
  padding-bottom: 6% !important;
}

.v-breadcrumbs__item {
  font-size: 14px !important;
  /* font-weight: normal; */
}

.v-slide-group__content_photo {
  display: flex;
  flex: 1 0 auto;
  position: relative;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  white-space: nowrap;
  padding-left: 30px !important;
}

.v-slide-group__content_photo-item--active::before,
.v-slide-group__content_photo-item:focus::before {
  opacity: 0 !important;
}

.no-margin-modelli {
  padding: 0 !important;
  margin: 0 !important;
  margin-top: -40px !important;
  font-weight: 400;
  font-size: 19px;
  text-align: left;
  width: 58%;
}

.testo_modelli_photo {
  font-size: 15px;
  font-weight: 600;
  margin-left: 30px !important;
  
}
.margin_negativo_30{
  margin-top: -30px !important;
}

.v-breadcrumbs {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  flex: 0 1 auto;
  list-style-type: none;
  margin: 0;
  padding: 5px 12px !important;
}

.occhio-centrato {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0%);
}
.v-card--link:focus:before {
  opacity: 0 !important;
}


</style>
